<template>

  <rate-calendar-bar
    :calendar-type="calendarType"
    :title="eventName"
    icon="$spotRate"
    :icon-color="verticalColor"
    is-exception
  >

    <template v-slot:extras>
      <p>{{ costRange }}</p>
    </template>

  </rate-calendar-bar>

</template>

<script setup lang="ts">

import RateCalendarBar from './RateCalendarBar.vue'
import type { EventExceptionItem } from '../types'
import VerticalRegistry from '../../../../../verticals/VerticalRegistry'
import { computed } from 'vue'
import { currencyFormatter } from '../../../../../utils/formatters'

interface Props {
  item: EventExceptionItem
  calendarType: string
}

const props = defineProps<Props>()

const verticalColor = VerticalRegistry.get('event')?.color

const eventName = computed<string>(() => {
  return props.item.inventory.event?.name ?? '(unknown event)'
})

const costRange = computed<string>(() => {

  const costs = props.item.inventory.eventTiers.map(t => t.tierPrice).toSorted()
  const lowestCost = costs.at(0) ?? null
  const highestCost = costs.at(-1) ?? null

  if (lowestCost === null || highestCost === null) {
    return ''
  } else if (lowestCost === highestCost) {
    return currencyFormatter.format(lowestCost)
  } else {
    return `${currencyFormatter.format(lowestCost)} – ${currencyFormatter.format(highestCost)}`
  }

})

</script>
